/**
 * 環境配置資料介面
 */
export interface Environment {
  id?: string;
  clientId: string;
  companyid: string;
  domain: string;
  production: boolean;
  title: string;
  favicon: string;
  apiUrl: string;
  companyname: string;
  copyright: string;
  logoUrl: string;
  Login_title: string;
  security?: {
    MFA: boolean;
  };
  login_page_setting: {
    title_text: string;
    id_text: string;
    pw_text: string;
    login_text: string;
    forget_text: string;
  };
  css_file_name: string;
  assistantid: string;
  AzureBlob: {
    blobUrl: string;
    blobsasToken: string;
    PrivateContainerName: string;
    PublicContainerName: string;
  };
  version: string;
  // 新增的欄位
  departmentCount?: number;
  moduleCount?: number;
  showNoPermission?: boolean;
  moduleConfig?: ModuleConfig;
  createdAt?: Date;
  updatedAt?: Date;
}

/**
 * 公司資料介面
 */
export interface Company {
  companyid: string;
  companyname: string;
  userCount?: number;
}

/**
 * 客戶使用者資料介面
 */
export interface CustomerUser {
  id?: string;
  companyid: string;
  username: string;
  password: string;
  modules: UserModule[];
  email: string;
  mfa?: {
    enabled: boolean;
    secret?: string;
    backupCodes?: string[];
    setupAt?: string;
  };
  createdAt?: Date;
  updatedAt?: Date;
}

/**
 * 使用者模組權限介面
 */
export interface UserModule {
  assistantNo: string;
  permission: string;
}

/**
 * 模組配置資料介面
 */
export interface ModuleConfig {
  id?: string;
  companyid: string;
  show_nopermission: boolean;
  departments?: {
    introduce: string;
    items: DepartmentItem[];
  };
  lobby?: AssistantItem[];
  createdAt?: Date;
  updatedAt?: Date;
}

/**
 * 部門項目介面
 */
export interface DepartmentItem {
  dep_id: string;
  dep_name: string;
  dep_image_url: string;
  dep_content: string;
}

/**
 * 助手項目介面
 */
export interface AssistantItem {
  assistantNo: string;
  title: string;
  content: string;
  enable: boolean;
}

/**
 * 可用的AI助手類型
 */
export const AVAILABLE_ASSISTANTS: AssistantItem[] = [
  {
    assistantNo: 'e2d4c6b8-9a0b-4c3d-8e7f-1234567890ab',
    title: 'Admin',
    content: '系統管理',
    enable: false
  },
  {
    assistantNo: '240f2a88-5a0d-4d72-936e-ba54f9832c7e',
    title: '法令合規AI助手',
    content: '法令合規AI助手',
    enable: false
  },
  {
    assistantNo: '251f1d59-092b-49c6-b337-ecc7ac2b3ef7',
    title: '自動檢查',
    content: '自動檢查',
    enable: false
  }
];
